(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__vpPickerInit) return;
    window.__vpPickerInit = true;

    // "None" or "No Frame" (any case / spacing) = the no-frame color value
    function isNone(v) {
      return /^(none|no[\s-]?frame)$/i.test(String(v).trim());
    }

    function readVariants(vs) {
      var node = vs.querySelector('[data-variants-json]');
      try {
        return JSON.parse(node.textContent);
      } catch (e) {
        return [];
      }
    }

    function refresh(vs) {
      var variants = readVariants(vs);
      var groups = Array.prototype.slice.call(vs.querySelectorAll('fieldset[data-vp-group]'));
      var selected = groups.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });

      groups.forEach(function (g, gi) {
        var els = Array.prototype.slice.call(g.querySelectorAll('[data-vp-price]'));
        var prices = [];
        els.forEach(function (el) {
          var need = selected.slice();
          need[gi] = el.getAttribute('data-vp-price-val');
          var match = variants.filter(function (v) {
            return need.every(function (n) {
              return n === null || v.o.indexOf(n) !== -1;
            });
          })[0];
          el.textContent = match ? match.p : '';
          var card = el.closest('.vp-card');
          if (card) card.classList.toggle('is-soldout', !!match && !match.a);
          prices.push(match ? match.p : '');
        });
        if (g.hasAttribute('data-vp-hide-equal')) {
          var same = prices.every(function (p) { return p === prices[0]; });
          els.forEach(function (el) { el.hidden = same; });
        }
      });

      var checked = vs.querySelector('input.vp-size-input:checked');
      if (checked) {
        var label = vs.querySelector('[data-vp-size-label]');
        if (label) label.textContent = checked.getAttribute('data-vp-name');
        var summary = vs.querySelector('[data-vp-summary]');
        var total = checked.getAttribute('data-vp-total');
        var dims = checked.getAttribute('data-vp-dims');
        if (summary) {
          summary.textContent = total
            ? 'wall art, ' + dims + ' each. About ' + total + '" wide when hung with 2" gaps.'
            : '';
        }
      }
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('input[type="radio"]')) return;
      var vs = t.closest('variant-selects');
      if (vs) refresh(vs);
    });

    // Show/hide Frame color and keep a valid combo selected.
    // Rolled Canvas / Stretched Wall Art -> Frame color is set to None / No Frame automatically.
    // Float Frame -> first real color (or the one already chosen).
    // Capture phase: runs before Dawn reads the options, so Dawn never sees
    // an impossible combo like "Float Frame + None".
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('.frame-style-input')) return;
      var vs = t.closest('variant-selects');
      var fs = vs && vs.querySelector('[data-vp-color]');
      if (!fs) return;
      var isFloat = /float/i.test(t.value);
      var inputs = Array.prototype.slice.call(fs.querySelectorAll('input'));
      var current = fs.querySelector('input:checked');
      var target = null;
      inputs.forEach(function (i) {
        var none = isNone(i.value);
        if (isFloat && !none && !target) target = i;
        if (!isFloat && none) target = i;
      });
      if (isFloat && current && !isNone(current.value)) target = current;
      if (target) target.checked = true;
      fs.hidden = !isFloat;
    }, true);

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (t.closest('[data-vp-open-guide], a[href="#size-guide"]')) {
        var dialog = document.querySelector('dialog.vp-guide');
        if (dialog && dialog.showModal) {
          e.preventDefault();
          dialog.showModal();
        }
        return;
      }
      if (t.closest('[data-vp-close-guide]')) {
        t.closest('dialog').close();
        return;
      }
      if (t.matches('dialog.vp-guide')) t.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
